import React from 'react';
import BigOptionButton from '../../components/BigOptionButton';
import naturalUS from '../../assets/images/ribbons/cabinetRibbon/upperShelf/natural.png';
import {
  addOrUpdateFurnitureUpperShelfAction,
  addOrUpdateUpperShelfAction,
  displayUpperShelfPanelAction,
  removeFurnitureUpperShelfAction,
  removeUpperShelfAction,
} from './actions';
import {
  BLACK_COLOR,
  NATURAL_COLOR,
  WHITE_COLOR,
} from '../../lib/modelBuilder/constants';
import noUS from '../../assets/images/ribbons/cabinetRibbon/upperShelf/noUpperShelf.png';
import whiteUS from '../../assets/images/ribbons/cabinetRibbon/upperShelf/white.png';
import blackUS from '../../assets/images/ribbons/cabinetRibbon/upperShelf/black.png';
import { Cabinet } from '../../lib/modelBuilder/entities/Cabinet';
import { Furniture } from '../../lib/modelBuilder/entities/Furniture';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { restoreCabinet } from '../Configurator/actions/furniture';
import { createStructuredSelector } from 'reselect';
import { ApplicationRootState } from '../../types';
import {
  makeSelectLastHistoryCabinet,
  makeSelectLastHistoryFurniture,
} from '../Configurator/selectors/history';
import { makeSelectSelectedIdCabinet } from '../Configurator/selectors/furniture';

interface StateProps {
  cabinet: Cabinet;
  furniture: Furniture;
  selectedCabinetId: string | null;
}

const stateSelector = createStructuredSelector<
  ApplicationRootState,
  StateProps
>({
  cabinet: makeSelectLastHistoryCabinet(),
  furniture: makeSelectLastHistoryFurniture(),
  selectedCabinetId: makeSelectSelectedIdCabinet(),
});

const UpperShelfPanelContent = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { cabinet, furniture, selectedCabinetId } = useSelector(stateSelector);

  function onLeave() {
    // Restore the last history element
    dispatch(restoreCabinet(cabinet));
  }

  const hidePanel = () => {
    dispatch(displayUpperShelfPanelAction(false));
  };

  return (
    <>
      <BigOptionButton
        className="self-start mt-4"
        imgSrc={noUS}
        title={t('No upper shelf')}
        handleClick={() => {
          if (selectedCabinetId) dispatch(removeUpperShelfAction());
          else dispatch(removeFurnitureUpperShelfAction());
          hidePanel();
        }}
        handleHover={() => {
          if (selectedCabinetId) dispatch(removeUpperShelfAction(true));
          else dispatch(removeFurnitureUpperShelfAction(true));
        }}
        onLeave={onLeave}
        selected={!(cabinet.upperShelf || furniture.upperShelf)}
      />
      <BigOptionButton
        className="self-start mt-4"
        imgSrc={naturalUS}
        title={`${t('MDF')} ${t('Natural')}`}
        handleClick={() => {
          if (selectedCabinetId)
            dispatch(addOrUpdateUpperShelfAction(NATURAL_COLOR));
          else dispatch(addOrUpdateFurnitureUpperShelfAction(NATURAL_COLOR));
          hidePanel();
        }}
        handleHover={() => {
          if (selectedCabinetId)
            dispatch(addOrUpdateUpperShelfAction(NATURAL_COLOR, true));
          else
            dispatch(addOrUpdateFurnitureUpperShelfAction(NATURAL_COLOR, true));
        }}
        handleDoubleClick={() => {
          hidePanel();
        }}
        onLeave={onLeave}
        selected={
          (selectedCabinetId &&
            cabinet.upperShelf?.base.color.reference === NATURAL_COLOR) ||
          (!selectedCabinetId &&
            furniture.upperShelf?.base.color.reference === NATURAL_COLOR)
        }
      />

      <BigOptionButton
        className="self-start mt-4"
        imgSrc={whiteUS}
        title={t('White')}
        handleClick={() => {
          if (selectedCabinetId)
            dispatch(addOrUpdateUpperShelfAction(WHITE_COLOR));
          else dispatch(addOrUpdateFurnitureUpperShelfAction(WHITE_COLOR));
          hidePanel();
        }}
        handleHover={() => {
          if (selectedCabinetId)
            dispatch(addOrUpdateUpperShelfAction(WHITE_COLOR, true));
          else
            dispatch(addOrUpdateFurnitureUpperShelfAction(WHITE_COLOR, true));
        }}
        handleDoubleClick={() => {
          hidePanel();
        }}
        onLeave={onLeave}
        selected={
          (selectedCabinetId &&
            cabinet.upperShelf?.base.color.reference === WHITE_COLOR) ||
          (!selectedCabinetId &&
            furniture.upperShelf?.base.color.reference === WHITE_COLOR)
        }
      />
      <BigOptionButton
        className="self-start mt-4"
        imgSrc={blackUS}
        title={t('Black')}
        handleClick={() => {
          if (selectedCabinetId)
            dispatch(addOrUpdateUpperShelfAction(BLACK_COLOR));
          else dispatch(addOrUpdateFurnitureUpperShelfAction(BLACK_COLOR));
          hidePanel();
        }}
        handleHover={() => {
          if (selectedCabinetId)
            dispatch(addOrUpdateUpperShelfAction(BLACK_COLOR, true));
          else
            dispatch(addOrUpdateFurnitureUpperShelfAction(BLACK_COLOR, true));
        }}
        handleDoubleClick={() => {
          hidePanel();
        }}
        onLeave={onLeave}
        selected={
          (selectedCabinetId &&
            cabinet.upperShelf?.base.color.reference === BLACK_COLOR) ||
          (!selectedCabinetId &&
            furniture.upperShelf?.base.color.reference === BLACK_COLOR)
        }
      />
    </>
  );
};

export default UpperShelfPanelContent;
